import { html, property } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';

/**
 * @component {kat-metric-simple} KatMetricSimple Standardizes the display and layout of metrics "child” metrics.  Used inconjunction with the KatMetric component.
 * @status Production
 */
@register('kat-metric-simple')
export class KatMetricSimple extends KatLitElement {
  /** Whether the header should be clickable. */
  @property({ attribute: 'header-clickable' })
  headerClickable? = false;

  /** The title of the module, summarizing the content it contains. */
  @property()
  header: string;

  /** A secondary text area for secondary or clarifying information, such as a "last updated" timestamp. */
  @property()
  subheader?: string;

  /** The primary metric value to be displayed. */
  @property()
  metric: string;

  /** Optional trend value to be display */
  @property({ attribute: 'trend-value' })
  trendValue?: string;

  /**
   * The trend of a metric being displayed.
   * @enum {value} increase Increase in the observed value.
   * @enum {value} decrease Decrease in the observed value.
   * @enum {value} neutral No variation in the observed value.
   * @enum {value} missing No data is available.
   */
  @property()
  trend?: 'increase' | 'decrease' | 'neutral' | 'missing';

  /**
   * The polarity of the trend line.
   * @enum {value} positive The observed value has positive impact.
   * @enum {value} negative The observed value has negative impact.
   * @enum {value} neutral The observed value has no impact.
   */
  @property({ attribute: 'trend-polarity' })
  trendPolarity?: 'positive' | 'negative' | 'neutral' = 'neutral';

  render() {
    return html`<kat-metric
      header=${this.header}
      subheader=${this.subheader}
      metric=${this.metric}
      trend=${this.trend}
      trend-value=${this.trendValue}
      trend-polarity=${this.trendPolarity}
      ?header-clickable=${this.headerClickable}
      simple
    ></kat-metric>`;
  }
}
